export const getMasterProduct = (productsData, paramInternalType) => {
  try {
    const masterProduct = paramInternalType
      ? productsData.find(({ node }) => {
          return node.handle.includes(paramInternalType.toLowerCase())
        })?.node
      : productsData.find(({ node }) => {
          return !!node.variants.edges.find((v) => {
            return v.node.quantityAvailable > 0
          })
        })?.node

    return masterProduct || productsData[0]?.node
  } catch (error) {
    throw new Error('ERROR getMasterProduct: ', error)
  }
}

export const getOtherProducts = (productsData, paramInternalType) => {
  try {
    return paramInternalType
      ? productsData.filter(
          ({ node }) => !node.handle.includes(paramInternalType.toLowerCase())
        )
      : productsData.slice(1)
  } catch (error) {
    throw new Error('ERROR getOtherProducts: ', error)
  }
}

export const getMasterColor = (paramColor, product) => {
  try {
    const variantWithQty = product?.variants?.edges?.find(
      ({ node: { quantityAvailable } }) => quantityAvailable > 0
    )?.node
    const color =
      paramColor ||
      (variantWithQty
        ? variantWithQty?.selectedOptions?.find(
            ({ name }) => name.toLowerCase() === 'color'
          )?.value
        : product?.variants?.edges?.[0]?.node?.selectedOptions?.find(
            ({ name }) => name.toLowerCase() === 'color'
          )?.value)
    if (!color) throw new Error('master color not found')
    return color
  } catch (error) {
    throw new Error('ERROR getMasterColor: ', error)
  }
}

export const buildColorsFromOtherProducts = (
  otherProducts,
  locale,
  resultColors
) => {
  try {
    const localeSplit = locale.split('-')
    const lang = `${localeSplit[0]}-${localeSplit[1].toUpperCase()}`

    const colors = otherProducts.reduce((acc, { node: otherProduct }) => {
      const allColorSizes = getAllColorSizes(otherProduct.variants.edges)
      const itemColors = getItemColors(otherProduct, allColorSizes, lang)

      acc.push(...itemColors)
      return acc
    }, [])

    const allColors = [...resultColors, ...colors]
    const uniqueColors = allColors.reduce((acc, color) => {
      const existingColor = acc.find(
        (c) =>
          c.normalized_color === color.normalized_color &&
          c.internal_color_code === color.internal_color_code &&
          c.internal_type === color.internal_type
      )
      if (!existingColor) acc.push(color)
      return acc
    }, [])

    return uniqueColors
  } catch (error) {
    throw new Error('ERROR buildColorsFromOtherProducts: ', error)
  }
}

export const getItemColors = (otherProduct, allColorSizes, lang) => {
  try {
    const metafields = JSON.parse(otherProduct?.metafield?.value)
    const metafieldsColors = metafields?.[lang]?.colors
    const listColors = otherProduct.options.filter((option) => {
      return option.name.toLowerCase() === 'color'
    })

    return listColors[0]?.values.reduce((acc, color) => {
      if (metafields?.[lang]?.colors?.[color]) {
        const itemColor = {
          internal_color_code: color || null,
          availability: !!allColorSizes?.[color]?.length,
          availableSizes: allColorSizes?.[color] || null,
          normalized_color: metafieldsColors?.[color]?.normalized_color || null,
          sample_color: metafieldsColors?.[color]?.color_sample || null,
          internal_type: metafields?.[lang]?.global?.internal_type || null,
          // handleShopify: otherProduct?.handle || null,
        }

        acc.push(itemColor)
      }
      return acc
    }, [])
  } catch (error) {
    throw new Error('ERROR getItemColors: ', error)
  }
}

export const getAllColorSizes = (variants) => {
  try {
    return variants.reduce((acc, variant) => {
      const colorCode = variant.node.selectedOptions.find(
        ({ name }) => name.toLowerCase() === 'color'
      ).value
      const colorSize = variant.node.selectedOptions.find(
        ({ name }) => name.toLowerCase() === 'size'
      ).value

      if (variant.node.availableForSale) {
        if (!acc[colorCode]) acc[colorCode] = []
        acc[colorCode].push(colorSize)
      }

      return acc
    }, [])
  } catch (error) {
    throw new Error('ERROR getAllColorSizes: ', error)
  }
}
